import { z } from 'zod';

export const identityDTOSchema = z.object({
  provider: z.string(),
  userId: z.string(),
  connection: z.string(),
  isSocial: z.boolean(),
});

export const identityArrayDTOSchema = z.array(identityDTOSchema);
